import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7073/Campaigns";
	}
	constructConditionClauseText(e, t) {
		let n = this.baseUrl + "/ConstructConditionClauseText";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processConstructConditionClauseText(e)));
	}
	processConstructConditionClauseText(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getSpecialConditionBank(e) {
		let t = this.baseUrl + "/GetSpecialConditionBank";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetSpecialConditionBank(e)));
	}
	processGetSpecialConditionBank(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetSpecialConditions(e, t, n) {
		let r = this.baseUrl + "/StaffGetSpecialConditions?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", t != null && (r += "contractId=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetSpecialConditions(e)));
	}
	processStaffGetSpecialConditions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractSpecialConditionDueDate(e, t) {
		let n = this.baseUrl + "/StaffUpdateContractSpecialConditionDueDate";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateContractSpecialConditionDueDate(e)));
	}
	processStaffUpdateContractSpecialConditionDueDate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractSpecialConditions(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractSpecialConditions?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractSpecialConditions(e)));
	}
	processStaffUpdateContractSpecialConditions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	negotiate(e) {
		let t = this.baseUrl + "/Negotiate";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processNegotiate(e)));
	}
	processNegotiate(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSearchForCampaign(e, t, n, r) {
		let i = this.baseUrl + "/StaffSearchForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
		if (i += "searchTerm=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'searchForArchived' must be defined and cannot be null.");
		i += "searchForArchived=" + encodeURIComponent("" + t) + "&", n != null && (i += "continuationToken=" + encodeURIComponent("" + n) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffSearchForCampaign(e)));
	}
	processStaffSearchForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	formsByLocations(e) {
		let t = this.baseUrl + "/FormsByLocations";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processFormsByLocations(e)));
	}
	processFormsByLocations(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	loadForm(e, t, n) {
		let r = this.baseUrl + "/LoadForm?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'formId' must be defined and cannot be null.");
		r += "formId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processLoadForm(e)));
	}
	processLoadForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	saveForm(e, t) {
		let n = this.baseUrl + "/SaveForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSaveForm(e)));
	}
	processSaveForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	sendForm(e, t) {
		let n = this.baseUrl + "/SendForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSendForm(e)));
	}
	processSendForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	submitForm(e, t) {
		let n = this.baseUrl + "/SubmitForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSubmitForm(e)));
	}
	processSubmitForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getUploadedFileLink(e, t) {
		let n = this.baseUrl + "/GetUploadedFileLink?";
		if (e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		n += "filePath=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removeFile(e, t) {
		let n = this.baseUrl + "/RemoveFile";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	addOrUpdateDocument(e, t, n, r, i) {
		let a = this.baseUrl + "/AddOrUpdateDocument?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'documentType' must be defined and cannot be null.");
		a += "documentType=" + encodeURIComponent("" + t) + "&", n != null && (a += "contractId=" + encodeURIComponent("" + n) + "&"), r != null && (a += "filePath=" + encodeURIComponent("" + r) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "POST",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processAddOrUpdateDocument(e)));
	}
	processAddOrUpdateDocument(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	exchangeContract(e, t) {
		let n = this.baseUrl + "/ExchangeContract";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processExchangeContract(e)));
	}
	processExchangeContract(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	performContractAction(e, t) {
		let n = this.baseUrl + "/PerformContractAction";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processPerformContractAction(e)));
	}
	processPerformContractAction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBuyersAgent(e, t) {
		let n = this.baseUrl + "/StaffGetBuyersAgent?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBuyersAgent(e)));
	}
	processStaffGetBuyersAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBuyers(e, t) {
		let n = this.baseUrl + "/StaffGetBuyers?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBuyers(e)));
	}
	processStaffGetBuyers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBuyersSolicitor(e, t) {
		let n = this.baseUrl + "/StaffGetBuyersSolicitor?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBuyersSolicitor(e)));
	}
	processStaffGetBuyersSolicitor(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractDates(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractDates?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractDates(e)));
	}
	processStaffGetContractDates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractDeposits(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractDeposits?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractDeposits(e)));
	}
	processStaffGetContractDeposits(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractEarlyRelease(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractEarlyRelease?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractEarlyRelease(e)));
	}
	processStaffGetContractEarlyRelease(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractSettlement(e, t, n) {
		let r = this.baseUrl + "/StaffGetContractSettlement?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractSettlement(e)));
	}
	processStaffGetContractSettlement(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetSaleInformation(e, t, n) {
		let r = this.baseUrl + "/StaffGetSaleInformation?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetSaleInformation(e)));
	}
	processStaffGetSaleInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffPreviewLinkedDates(e, t, n, r) {
		let i = this.baseUrl + "/StaffPreviewLinkedDates?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffPreviewLinkedDates(e)));
	}
	processStaffPreviewLinkedDates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBuyersAgent(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBuyersAgent?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBuyersAgent(e)));
	}
	processStaffUpdateBuyersAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBuyers(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBuyers?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBuyers(e)));
	}
	processStaffUpdateBuyers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBuyersSolicitor(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBuyersSolicitor?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBuyersSolicitor(e)));
	}
	processStaffUpdateBuyersSolicitor(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractComplianceFields(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractComplianceFields?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractComplianceFields(e)));
	}
	processStaffUpdateContractComplianceFields(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractDates(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractDates?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractDates(e)));
	}
	processStaffUpdateContractDates(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractDeposits(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateContractDeposits?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractDeposits(e)));
	}
	processStaffUpdateContractDeposits(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractEarlyRelease(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateContractEarlyRelease?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractEarlyRelease(e)));
	}
	processStaffUpdateContractEarlyRelease(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractSettlement(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateContractSettlement?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractSettlement(e)));
	}
	processStaffUpdateContractSettlement(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateContractTermination(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateContractTermination?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractTermination(e)));
	}
	processStaffUpdateContractTermination(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateSaleInformation(e, t, n, r) {
		let i = this.baseUrl + "/StaffUpdateSaleInformation?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent("" + t) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			data: JSON.stringify(n),
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateSaleInformation(e)));
	}
	processStaffUpdateSaleInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	beginCampaign(e, t) {
		let n = this.baseUrl + "/BeginCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processBeginCampaign(e)));
	}
	processBeginCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	completeCampaignStep(e, t) {
		let n = this.baseUrl + "/CompleteCampaignStep";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCompleteCampaignStep(e)));
	}
	processCompleteCampaignStep(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getActiveCampaigns(e) {
		let t = this.baseUrl + "/GetActiveCampaigns";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetActiveCampaigns(e)));
	}
	processGetActiveCampaigns(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getArchivedCampaignsByAgency(e) {
		let t = this.baseUrl + "/GetArchivedCampaignsByAgency";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetArchivedCampaignsByAgency(e)));
	}
	processGetArchivedCampaignsByAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCampaign(e, t) {
		let n = this.baseUrl + "/GetCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCampaign(e)));
	}
	processGetCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	performCampaignAction(e, t) {
		let n = this.baseUrl + "/PerformCampaignAction";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processPerformCampaignAction(e)));
	}
	processPerformCampaignAction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removeFormSubmission(e, t) {
		let n = this.baseUrl + "/RemoveFormSubmission";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemoveFormSubmission(e)));
	}
	processRemoveFormSubmission(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getArchivedCampaignsByAdmin(e, t) {
		let n = this.baseUrl + "/GetArchivedCampaignsByAdmin?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetArchivedCampaignsByAdmin(e)));
	}
	processGetArchivedCampaignsByAdmin(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCampaignsForAgency(e, t) {
		let n = this.baseUrl + "/GetCampaignsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCampaignsForAgency(e)));
	}
	processGetCampaignsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setCampaignOwnership(e, t) {
		let n = this.baseUrl + "/SetCampaignOwnership";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetCampaignOwnership(e)));
	}
	processSetCampaignOwnership(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffBeginCampaign(e, t) {
		let n = this.baseUrl + "/StaffBeginCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffBeginCampaign(e)));
	}
	processStaffBeginCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetCampaign(e)));
	}
	processStaffGetCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCampaignDashboard(e, t, n, r, i, a, o, s, c, l) {
		let u = this.baseUrl + "/StaffGetCampaignDashboard?";
		e != null && e && e.forEach((e) => {
			u += "agencyIds=" + encodeURIComponent("" + e) + "&";
		}), t != null && t && t.forEach((e) => {
			u += "campaignStatuses=" + encodeURIComponent("" + e) + "&";
		}), n != null && n && n.forEach((e) => {
			u += "launchDateStatuses=" + encodeURIComponent("" + e) + "&";
		}), r != null && r && r.forEach((e) => {
			u += "marketingStatuses=" + encodeURIComponent("" + e) + "&";
		}), i != null && i && i.forEach((e) => {
			u += "blankContractStatuses=" + encodeURIComponent("" + e) + "&";
		}), a != null && (u += "addressSearch=" + encodeURIComponent("" + a) + "&"), o != null && (u += "continuationToken=" + encodeURIComponent("" + o) + "&"), s != null && (u += "pageSize=" + encodeURIComponent("" + s) + "&"), c != null && (u += "sortingOption=" + encodeURIComponent("" + c) + "&"), u = u.replace(/[?&]$/, "");
		let d = {
			method: "GET",
			url: u,
			headers: { Accept: "application/json" },
			signal: l
		};
		return this.transformOptions(d).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(u, e, (e) => this.processStaffGetCampaignDashboard(e)));
	}
	processStaffGetCampaignDashboard(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractDashboard(e, t, n, r, i, a, o) {
		let s = this.baseUrl + "/StaffGetContractDashboard?";
		e != null && e && e.forEach((e) => {
			s += "agencyIds=" + encodeURIComponent("" + e) + "&";
		}), t != null && t && t.forEach((e) => {
			s += "contractStatuses=" + encodeURIComponent("" + e) + "&";
		}), n != null && n && n.forEach((e) => {
			s += "settlementDateStatuses=" + encodeURIComponent("" + e) + "&";
		}), r != null && r && r.forEach((e) => {
			s += "vendorBankDetailsStatuses=" + encodeURIComponent("" + e) + "&";
		}), i != null && (s += "addressSearch=" + encodeURIComponent("" + i) + "&"), a != null && (s += "sortingOptionContractDashboard=" + encodeURIComponent("" + a) + "&"), s = s.replace(/[?&]$/, "");
		let c = {
			method: "GET",
			url: s,
			headers: { Accept: "application/json" },
			signal: o
		};
		return this.transformOptions(c).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(s, e, (e) => this.processStaffGetContractDashboard(e)));
	}
	processStaffGetContractDashboard(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContract(e, t) {
		let n = this.baseUrl + "/StaffGetContract?";
		if (e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		n += "contractId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetContract(e)));
	}
	processStaffGetContract(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetContractsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetContractsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetContractsForCampaign(e)));
	}
	processStaffGetContractsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetDocumentsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetDocumentsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetDocumentsForCampaign(e)));
	}
	processStaffGetDocumentsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetFormConfiguration(e, t) {
		let n = this.baseUrl + "/StaffGetFormConfiguration";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetFormConfiguration(e)));
	}
	processStaffGetFormConfiguration(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetUploadedFileLink(e, t) {
		let n = this.baseUrl + "/StaffGetUploadedFileLink?";
		if (e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		n += "filePath=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "text/plain" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetUploadedFileLink(e)));
	}
	processStaffGetUploadedFileLink(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSaveForm(e, t) {
		let n = this.baseUrl + "/StaffSaveForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffSaveForm(e)));
	}
	processStaffSaveForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSubmitForm(e, t) {
		let n = this.baseUrl + "/StaffSubmitForm";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffSubmitForm(e)));
	}
	processStaffSubmitForm(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetBlankContractDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetBlankContractDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetBlankContractDetailsForCampaign(e)));
	}
	processStaffGetBlankContractDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPropertyDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetPropertyDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPropertyDetailsForCampaign(e)));
	}
	processStaffGetPropertyDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPropertyInformationProgressForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetPropertyInformationProgressForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPropertyInformationProgressForCampaign(e)));
	}
	processStaffGetPropertyInformationProgressForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetTenancyInformationForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetTenancyInformationForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetTenancyInformationForCampaign(e)));
	}
	processStaffGetTenancyInformationForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetVendorDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetVendorDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetVendorDetailsForCampaign(e)));
	}
	processStaffGetVendorDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateBlankContractDetailsForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateBlankContractDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateBlankContractDetailsForCampaign(e)));
	}
	processStaffUpdateBlankContractDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdatePropertyDetailsForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdatePropertyDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdatePropertyDetailsForCampaign(e)));
	}
	processStaffUpdatePropertyDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateTenancyInformationForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateTenancyInformationForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateTenancyInformationForCampaign(e)));
	}
	processStaffUpdateTenancyInformationForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateVendorDetailsForCampaign(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateVendorDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateVendorDetailsForCampaign(e)));
	}
	processStaffUpdateVendorDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetAgreementDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetAgreementDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetAgreementDetailsForCampaign(e)));
	}
	processStaffGetAgreementDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCommissionInfoForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetCommissionInfoForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetCommissionInfoForCampaign(e)));
	}
	processStaffGetCommissionInfoForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetExternalConjunction(e, t) {
		let n = this.baseUrl + "/StaffGetExternalConjunction?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetExternalConjunction(e)));
	}
	processStaffGetExternalConjunction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetLaunchDateDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetLaunchDateDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetLaunchDateDetailsForCampaign(e)));
	}
	processStaffGetLaunchDateDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPhotosAndMediaDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffGetPhotosAndMediaDetailsForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffGetPhotosAndMediaDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateAgreementDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateAgreementDetailsForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateAgreementDetailsForCampaign(e)));
	}
	processStaffUpdateAgreementDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateCommissionInfoForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateCommissionInfoForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateCommissionInfoForCampaign(e)));
	}
	processStaffUpdateCommissionInfoForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateExternalConjunction(e, t, n) {
		let r = this.baseUrl + "/StaffUpdateExternalConjunction?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateExternalConjunction(e)));
	}
	processStaffUpdateExternalConjunction(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateLaunchDateForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateLaunchDateForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateLaunchDateForCampaign(e)));
	}
	processStaffUpdateLaunchDateForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdatePhotosAndMediaDetailsForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdatePhotosAndMediaDetailsForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdatePhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffUpdatePhotosAndMediaDetailsForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateServiceFeeInfoForCampaign(e, t) {
		let n = this.baseUrl + "/StaffUpdateServiceFeeInfoForCampaign";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (J(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateServiceFeeInfoForCampaign(e)));
	}
	processStaffUpdateServiceFeeInfoForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return q("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return q("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.And = "And", e.Or = "Or", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.EQ = "EQ", e.NEQ = "NEQ", e.LT = "LT", e.GT = "GT", e.LTEQ = "LTEQ", e.GTEQ = "GTEQ", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.AdditionalDocumentations = "AdditionalDocumentations", e.AddressSearch = "AddressSearch", e.BuyersAgentSearch = "BuyersAgentSearch", e.AgreementDetails = "AgreementDetails", e.BuildingAndPest = "BuildingAndPest", e.VendorBuyerDetails = "VendorBuyerDetails", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.ContractDeposit = "ContractDeposit", e.DepositPayable = "DepositPayable", e.Dropdown = "Dropdown", e.Date = "Date", e.DateTime = "DateTime", e.TextInput = "TextInput", e.Radio = "Radio", e.InfoLabel = "InfoLabel", e.PropertySearch = "PropertySearch", e.SolicitorSearch = "SolicitorSearch", e.ListingAgentSelector = "ListingAgentSelector", e.Commission = "Commission", e.PersonName = "PersonName", e.Checkbox = "Checkbox", e.MarketingPackage = "MarketingPackage", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.ReviewAndSign = "ReviewAndSign", e.AlternateAddressSearch = "AlternateAddressSearch", e.FileUpload = "FileUpload", e.TenantedProperty = "TenantedProperty", e.TypedDocumentUpload = "TypedDocumentUpload", e.POADocumentUpload = "POADocumentUpload", e.TextArea = "TextArea", e.SaleDetails = "SaleDetails", e.LaunchDetails = "LaunchDetails", e.SpecialConditions = "SpecialConditions", e.YesNoQuestion = "YesNoQuestion", e.SettlementDate = "SettlementDate", e.SendForDocuSigning = "SendForDocuSigning", e.SignboardRemoval = "SignboardRemoval", e.MarketingContributions = "MarketingContributions", e.DisplayPrice = "DisplayPrice", e.PriceSpecification = "PriceSpecification", e.Currency = "Currency", e.SubjectToFinance = "SubjectToFinance", e.AdjustmentToCommission = "AdjustmentToCommission", e.ExternalConjunction = "ExternalConjunction", e.PropertyType = "PropertyType", e.VendorDetailsDisplay = "VendorDetailsDisplay", e.ConditionalTextInput = "ConditionalTextInput", e.SecondaryAgentCommissionSplit = "SecondaryAgentCommissionSplit", e.TenancyDetails = "TenancyDetails", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.LegalDescription = "LegalDescription", e.PropertyAttributes = "PropertyAttributes", e.ChattelsIncluded = "ChattelsIncluded", e.RuralParticulars = "RuralParticulars", e.PriceOpinion = "PriceOpinion", e.EditablePdfUpload = "EditablePdfUpload", e.Deposit = "Deposit", e.CoolingOffPeriod = "CoolingOffPeriod", e.Image = "Image", e.Alerts = "Alerts", e.MarketingConfirmation = "MarketingConfirmation", e.MarketingLaunchDetails = "MarketingLaunchDetails", e.SellersDisclosurePreparedBy = "SellersDisclosurePreparedBy", e.BodyCorporate = "BodyCorporate", e.SellersDisclosureUpload = "SellersDisclosureUpload", e.CommunityTitlesScheme = "CommunityTitlesScheme", e.BodyCorporateRecords = "BodyCorporateRecords", e.SurveyPlanUpload = "SurveyPlanUpload", e.IdentityVerificationExports = "IdentityVerificationExports", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Information = "Information", e.Action = "Action", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.HouseAndLand = "HouseAndLand", e.CommunityTitles = "CommunityTitles", e.NewContract2025 = "NewContract2025", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.PhotoIdCard = "PhotoIdCard", e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e.None = "None", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Australia = "Australia", e.NewSouthWales = "NewSouthWales", e.Other = "Other", e.Queensland = "Queensland", e.Victoria = "Victoria", e.NorthernTerritory = "NorthernTerritory", e.SouthAustralia = "SouthAustralia", e.WesternAustralia = "WesternAustralia", e.AustralianCapitalTerritory = "AustralianCapitalTerritory", e.Tasmania = "Tasmania", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.InPerson = "InPerson", e.Biometric = "Biometric", e.NoPhotoId = "NoPhotoId", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Downsizing = "Downsizing", e.Upsizing = "Upsizing", e.Relocating = "Relocating", e.Other = "Other", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.FullTime = "FullTime", e.PartTime = "PartTime", e.Casual = "Casual", e.Unemployed = "Unemployed", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), ne = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), re = /* @__PURE__ */ function(e) {
	return e.FullEdit = "FullEdit", e.PartialEdit = "PartialEdit", e.ReadOnly = "ReadOnly", e;
}({}), ie = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), ae = /* @__PURE__ */ function(e) {
	return e.Other = "Other", e.ToBeAdvised = "ToBeAdvised", e;
}({}), oe = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), se = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ce = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Email = "Email", e.Phone = "Phone", e.Currency = "Currency", e.TextArea = "TextArea", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.NotTenanted = "NotTenanted", e.TenantedAgencyManaged = "TenantedAgencyManaged", e.TenantedSelfManaged = "TenantedSelfManaged", e.Unknown = "Unknown", e.TenantedAgencyManagedHolidayRental = "TenantedAgencyManagedHolidayRental", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Weekly = "Weekly", e.Fortnightly = "Fortnightly", e.Monthly = "Monthly", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.NoPool = "NoPool", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.Form36 = "Form36", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.None = "None", e.CompanyManaged = "CompanyManaged", e.SelfManaged = "SelfManaged", e.NonFunctioning = "NonFunctioning", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.On = "On", e.NDaysFrom = "NDaysFrom", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.BusinessDays = "BusinessDays", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.Weeks = "Weeks", e.Months = "Months", e.Years = "Years", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Finance = "Finance", e;
}({}), H = /* @__PURE__ */ function(e) {
	return e.OnDate = "OnDate", e.NdaysFromDate = "NdaysFromDate", e.OnSpecificDate = "OnSpecificDate", e.UponSatisfactionOfSpecialCondition = "UponSatisfactionOfSpecialCondition", e.AdditionalReason = "AdditionalReason", e.NotApplicable = "NotApplicable", e.NotSubjectToFinance = "NotSubjectToFinance", e.Other = "Other", e.AsPerContract = "AsPerContract", e.BuildingAndPestBeingSatisfied = "BuildingAndPestBeingSatisfied", e.FinanceBeingSatisfied = "FinanceBeingSatisfied", e.OnCoolingOffDate = "OnCoolingOffDate", e;
}({}), U = /* @__PURE__ */ function(e) {
	return e.JointTenants = "JointTenants", e.TenantsInCommon = "TenantsInCommon", e.Trustee = "Trustee", e.SoleProprietor = "SoleProprietor", e;
}({}), W = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), G = /* @__PURE__ */ function(e) {
	return e.Initial = "Initial", e.Balance = "Balance", e;
}({}), le = /* @__PURE__ */ function(e) {
	return e.IncludeShorteningOfCoolingOff = "IncludeShorteningOfCoolingOff", e.IncludeWaiverOfCoolingOff = "IncludeWaiverOfCoolingOff", e;
}({}), ue = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), de = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), fe = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), pe = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), me = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), he = /* @__PURE__ */ function(e) {
	return e.Exclusive = "Exclusive", e.Open = "Open", e.Sole = "Sole", e;
}({}), ge = /* @__PURE__ */ function(e) {
	return e.SingleRate = "SingleRate", e.MultiRate = "MultiRate", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.Flat = "Flat", e.Tiered = "Tiered", e.VendorChoice = "VendorChoice", e.Other = "Other", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.Search = "Search", e.Manual = "Manual", e.AttachAsFile = "AttachAsFile", e.NotAvailable = "NotAvailable", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.NoPoolCertificate = "NoPoolCertificate", e;
}({}), be = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), xe = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), Se = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), Ce = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), we = /* @__PURE__ */ function(e) {
	return e.FiveDays = "FiveDays", e.TenDays = "TenDays", e.NDays = "NDays", e.NoCoolingOff = "NoCoolingOff", e;
}({}), Te = /* @__PURE__ */ function(e) {
	return e.Waived = "Waived", e.Exempt = "Exempt", e;
}({}), Ee = /* @__PURE__ */ function(e) {
	return e.PartialDepositPaidUpfront = "PartialDepositPaidUpfront", e.FullDepositPaidUpfront = "FullDepositPaidUpfront", e;
}({}), De = /* @__PURE__ */ function(e) {
	return e.SalesAdvice = "SalesAdvice", e.ContractExchange = "ContractExchange", e;
}({}), Oe = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.UnderContract = "UnderContract", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), ke = /* @__PURE__ */ function(e) {
	return e.LaunchDateSet = "LaunchDateSet", e.LaunchDateNotSet = "LaunchDateNotSet", e.OffMarket = "OffMarket", e;
}({}), Ae = /* @__PURE__ */ function(e) {
	return e.Paid = "Paid", e.AwaitingFunds = "AwaitingFunds", e;
}({}), je = /* @__PURE__ */ function(e) {
	return e.Offline = "Offline", e.Live = "Live", e;
}({}), Me = /* @__PURE__ */ function(e) {
	return e.LaunchDateAsc = "LaunchDateAsc", e.LaunchDateDesc = "LaunchDateDesc", e;
}({}), Ne = /* @__PURE__ */ function(e) {
	return e.AwaitingExchange = "AwaitingExchange", e.PendingCompliance = "PendingCompliance", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e.Settled = "Settled", e.Terminated = "Terminated", e;
}({}), Pe = /* @__PURE__ */ function(e) {
	return e.SettlementDateSet = "SettlementDateSet", e.NoDateSet = "NoDateSet", e;
}({}), Fe = /* @__PURE__ */ function(e) {
	return e.Outstanding = "Outstanding", e.Complete = "Complete", e.Na = "Na", e;
}({}), Ie = /* @__PURE__ */ function(e) {
	return e.SettlementDateAsc = "SettlementDateAsc", e.SettlementDateDesc = "SettlementDateDesc", e;
}({}), Le = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Re = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), ze = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Be = /* @__PURE__ */ function(e) {
	return e.Restore = "Restore", e.RevertToCurrent = "RevertToCurrent", e.MarkAsUnderContract = "MarkAsUnderContract", e.MarkAsSold = "MarkAsSold", e.Archive = "Archive", e.Withdraw = "Withdraw", e;
}({}), Ve = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), He = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Ue = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), We = /* @__PURE__ */ function(e) {
	return e.Archived = "Archived", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), Ge = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), Ke = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), qe = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Je = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), Ye = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Xe = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), Ze = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), Qe = /* @__PURE__ */ function(e) {
	return e.RevertToAccepted = "RevertToAccepted", e.RevertToUnconditional = "RevertToUnconditional", e.MarkAsAwaitingExchange = "MarkAsAwaitingExchange", e.MarkAsAccepted = "MarkAsAccepted", e.MarkAsUnconditional = "MarkAsUnconditional", e.MarkSettled = "MarkSettled", e.Terminated = "Terminated", e.Cancelled = "Cancelled", e;
}({}), $e = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e;
}({}), et = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e;
}({}), tt = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), nt = /* @__PURE__ */ function(e) {
	return e.Manual = "Manual", e.DocuSign = "DocuSign", e.Email = "Email", e;
}({}), rt = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), it = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), at = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), ot = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), st = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ct = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), lt = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ut = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), dt = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Staff = "Staff", e;
}({}), ft = /* @__PURE__ */ function(e) {
	return e.None = "None", e.ForwardAndBack = "ForwardAndBack", e.BackAndReview = "BackAndReview", e.BackAndSubmit = "BackAndSubmit", e.Forward = "Forward", e;
}({}), pt = /* @__PURE__ */ function(e) {
	return e.Send = "Send", e.GeneratePdf = "GeneratePdf", e;
}({}), mt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), ht = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), gt = /* @__PURE__ */ function(e) {
	return e.PhotoIdCard = "PhotoIdCard", e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e.None = "None", e;
}({}), _t = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), vt = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), yt = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), bt = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), xt = /* @__PURE__ */ function(e) {
	return e.Complete = "Complete", e.Future = "Future", e.FutureDisabled = "FutureDisabled", e.Invalid = "Invalid", e;
}({}), St = /* @__PURE__ */ function(e) {
	return e.PhotoIdCard = "PhotoIdCard", e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e.None = "None", e;
}({}), Ct = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), wt = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Tt = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), Et = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), Dt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Ot = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), kt = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), At = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), jt = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Mt = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Nt = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Pt = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Ft = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), It = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Lt = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), Rt = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), zt = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), Bt = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Vt = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), Ht = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.NoDepositReceived = "NoDepositReceived", e;
}({}), Ut = /* @__PURE__ */ function(e) {
	return e.CoolingOffPeriod = "CoolingOffPeriod", e.FailedFinance = "FailedFinance", e.FailedBuildingAndPest = "FailedBuildingAndPest", e.SpecialConditions = "SpecialConditions", e;
}({}), Wt = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), Gt = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Kt = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), qt = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), Jt = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), Yt = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), Xt = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Docusign = "Docusign", e;
}({}), Zt = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), Qt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), $t = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), en = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), tn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), nn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), rn = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), an = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), on = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), sn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), cn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), ln = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), un = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), dn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), fn = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), pn = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), mn = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), hn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), gn = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), _n = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), vn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), yn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), bn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), xn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Sn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Cn = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), wn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Tn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), En = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), Dn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), On = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), kn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), An = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), jn = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), Mn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Nn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Pn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Fn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), In = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ln = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e;
}({}), Rn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), zn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Bn = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), K = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCampaignsApiException = !0;
	static isCampaignsApiException(e) {
		return e.isCampaignsApiException === !0;
	}
};
function q(e, t, n, r, i) {
	throw i ?? new K(e, t, n, r, null);
}
function J(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var Y = "campaigns";
function Vn(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var X = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), Vn(r);
}, Hn = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[Y] || `${e}/${Y}`;
}, Z = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = Hn(i), u = c, d = X(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(X(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, Q = a({}), Un = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Z(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(Q.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, Wn = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.constructConditionClauseText(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		constructConditionClauseText: u,
		constructConditionClauseTextPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Gn = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getSpecialConditionBank"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getSpecialConditionBank(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Kn = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getSpecialConditionBank"] });
	}, e[0] = t, e[1] = n), n;
}, qn = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSpecialConditions",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSpecialConditions(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Jn = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSpecialConditions",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Yn = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateContractSpecialConditionDueDate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSpecialConditionDueDate: u,
		staffUpdateContractSpecialConditionDueDatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Xn = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractSpecialConditions(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSpecialConditions: u,
		staffUpdateContractSpecialConditionsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Zn = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async () => a.negotiate(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		negotiate: u,
		negotiatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Qn = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(Q), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"staffSearchForCampaign",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.staffSearchForCampaign(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, $n = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"staffSearchForCampaign",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, er = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async () => a.formsByLocations(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		formsByLocations: u,
		formsByLocationsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, tr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"loadForm",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.loadForm(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, nr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"loadForm",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, rr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.saveForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		saveForm: u,
		saveFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ir = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendForm: u,
		sendFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ar = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.submitForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		submitForm: u,
		submitFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, or = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, sr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, cr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFile(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFile: u,
		removeFilePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, lr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, documentType: n, contractId: r, filePath: i } = e;
		return a.addOrUpdateDocument(t, n, r, i);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		addOrUpdateDocument: u,
		addOrUpdateDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ur = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.exchangeContract(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		exchangeContract: u,
		exchangeContractPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, dr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.performContractAction(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		performContractAction: u,
		performContractActionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, fr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersAgent", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersAgent(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, pr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersAgent", e] });
	}, e[0] = t, e[1] = n), n;
}, mr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyers(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, hr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyers", e] });
	}, e[0] = t, e[1] = n), n;
}, gr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersSolicitor", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersSolicitor(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, _r = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersSolicitor", e] });
	}, e[0] = t, e[1] = n), n;
}, vr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDates",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDates(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, yr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDates",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, br = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDeposits",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDeposits(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, xr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDeposits",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Sr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractEarlyRelease",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractEarlyRelease(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Cr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractEarlyRelease",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, wr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractSettlement",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractSettlement(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Tr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractSettlement",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Er = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSaleInformation",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSaleInformation(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Dr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSaleInformation",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Or = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffPreviewLinkedDates(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffPreviewLinkedDates: u,
		staffPreviewLinkedDatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, kr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyersAgent(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyersAgent: u,
		staffUpdateBuyersAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ar = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyers(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyers: u,
		staffUpdateBuyersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, jr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyersSolicitor(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyersSolicitor: u,
		staffUpdateBuyersSolicitorPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Mr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractComplianceFields(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractComplianceFields: u,
		staffUpdateContractComplianceFieldsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Nr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractDates(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractDates: u,
		staffUpdateContractDatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Pr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractDeposits(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractDeposits: u,
		staffUpdateContractDepositsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Fr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractEarlyRelease(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractEarlyRelease: u,
		staffUpdateContractEarlyReleasePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ir = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractSettlement(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSettlement: u,
		staffUpdateContractSettlementPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Lr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractTermination(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractTermination: u,
		staffUpdateContractTerminationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Rr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateSaleInformation(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateSaleInformation: u,
		staffUpdateSaleInformationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, zr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.beginCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		beginCampaign: u,
		beginCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Br = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.completeCampaignStep(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		completeCampaignStep: u,
		completeCampaignStepPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Vr = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getActiveCampaigns"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getActiveCampaigns(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Hr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getActiveCampaigns"] });
	}, e[0] = t, e[1] = n), n;
}, Ur = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getArchivedCampaignsByAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getArchivedCampaignsByAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Wr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAgency"] });
	}, e[0] = t, e[1] = n), n;
}, Gr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Kr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, qr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.performCampaignAction(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		performCampaignAction: u,
		performCampaignActionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Jr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFormSubmission(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFormSubmission: u,
		removeFormSubmissionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Yr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getArchivedCampaignsByAdmin", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getArchivedCampaignsByAdmin(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Xr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAdmin", e] });
	}, e[0] = t, e[1] = n), n;
}, Zr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaignsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaignsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Qr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaignsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, $r = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setCampaignOwnership(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setCampaignOwnership: u,
		setCampaignOwnershipPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ei = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffBeginCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffBeginCampaign: u,
		staffBeginCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ti = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ni = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, ri = (e, t, n, i, a, s, c, l, d, f) => {
	let p = r(29), m = f === void 0 ? !0 : f, h = o(Q), g;
	p[0] !== s || p[1] !== e || p[2] !== a || p[3] !== t || p[4] !== c || p[5] !== n || p[6] !== i || p[7] !== l || p[8] !== d ? (g = [
		"staffGetCampaignDashboard",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d
	], p[0] = s, p[1] = e, p[2] = a, p[3] = t, p[4] = c, p[5] = n, p[6] = i, p[7] = l, p[8] = d, p[9] = g) : g = p[9];
	let _ = g, v;
	p[10] !== s || p[11] !== e || p[12] !== h || p[13] !== a || p[14] !== t || p[15] !== c || p[16] !== n || p[17] !== i || p[18] !== l || p[19] !== d ? (v = (r) => {
		let { signal: o } = r;
		return h.staffGetCampaignDashboard(e, t, n, i, a, s, c, l, d, o);
	}, p[10] = s, p[11] = e, p[12] = h, p[13] = a, p[14] = t, p[15] = c, p[16] = n, p[17] = i, p[18] = l, p[19] = d, p[20] = v) : v = p[20];
	let y = m && !!h, b;
	p[21] !== _ || p[22] !== v || p[23] !== y ? (b = {
		queryKey: _,
		queryFn: v,
		enabled: y
	}, p[21] = _, p[22] = v, p[23] = y, p[24] = b) : b = p[24];
	let { data: x, isPending: S, isError: C } = u(b), w;
	return p[25] !== x || p[26] !== C || p[27] !== S ? (w = {
		data: x,
		isPending: S,
		isError: C
	}, p[25] = x, p[26] = C, p[27] = S, p[28] = w) : w = p[28], w;
}, ii = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetCampaignDashboard",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l
		] });
	}, e[0] = t, e[1] = n), n;
}, ai = (e, t, n, i, a, s, c) => {
	let l = r(23), d = c === void 0 ? !0 : c, f = o(Q), p;
	l[0] !== a || l[1] !== e || l[2] !== t || l[3] !== n || l[4] !== s || l[5] !== i ? (p = [
		"staffGetContractDashboard",
		e,
		t,
		n,
		i,
		a,
		s
	], l[0] = a, l[1] = e, l[2] = t, l[3] = n, l[4] = s, l[5] = i, l[6] = p) : p = l[6];
	let m = p, h;
	l[7] !== a || l[8] !== e || l[9] !== f || l[10] !== t || l[11] !== n || l[12] !== s || l[13] !== i ? (h = (r) => {
		let { signal: o } = r;
		return f.staffGetContractDashboard(e, t, n, i, a, s, o);
	}, l[7] = a, l[8] = e, l[9] = f, l[10] = t, l[11] = n, l[12] = s, l[13] = i, l[14] = h) : h = l[14];
	let g = d && !!f, _;
	l[15] !== m || l[16] !== h || l[17] !== g ? (_ = {
		queryKey: m,
		queryFn: h,
		enabled: g
	}, l[15] = m, l[16] = h, l[17] = g, l[18] = _) : _ = l[18];
	let { data: v, isPending: y, isError: b } = u(_), x;
	return l[19] !== v || l[20] !== b || l[21] !== y ? (x = {
		data: v,
		isPending: y,
		isError: b
	}, l[19] = v, l[20] = b, l[21] = y, l[22] = x) : x = l[22], x;
}, oi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDashboard",
			e,
			n,
			r,
			i,
			a,
			o
		] });
	}, e[0] = t, e[1] = n), n;
}, si = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContract", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContract(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ci = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContract", e] });
	}, e[0] = t, e[1] = n), n;
}, li = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContractsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContractsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ui = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContractsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, di = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetDocumentsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetDocumentsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetDocumentsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, pi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffGetFormConfiguration(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffGetFormConfiguration: u,
		staffGetFormConfigurationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, mi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, hi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, gi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSaveForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSaveForm: u,
		staffSaveFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, _i = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSubmitForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSubmitForm: u,
		staffSubmitFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, vi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBlankContractDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBlankContractDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, yi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBlankContractDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, bi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, xi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyInformationProgressForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyInformationProgressForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Si = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyInformationProgressForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ci = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetTenancyInformationForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetTenancyInformationForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, wi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetTenancyInformationForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ti = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetVendorDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetVendorDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ei = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetVendorDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Di = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateBlankContractDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBlankContractDetailsForCampaign: u,
		staffUpdateBlankContractDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Oi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdatePropertyDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdatePropertyDetailsForCampaign: u,
		staffUpdatePropertyDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ki = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateTenancyInformationForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateTenancyInformationForCampaign: u,
		staffUpdateTenancyInformationForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ai = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateVendorDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateVendorDetailsForCampaign: u,
		staffUpdateVendorDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ji = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgreementDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgreementDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Mi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgreementDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ni = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCommissionInfoForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCommissionInfoForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Pi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCommissionInfoForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Fi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetExternalConjunction", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetExternalConjunction(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ii = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetExternalConjunction", e] });
	}, e[0] = t, e[1] = n), n;
}, Li = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetLaunchDateDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetLaunchDateDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ri = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetLaunchDateDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, zi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPhotosAndMediaDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPhotosAndMediaDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Bi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPhotosAndMediaDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Vi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateAgreementDetailsForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateAgreementDetailsForCampaign: u,
		staffUpdateAgreementDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Hi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateCommissionInfoForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateCommissionInfoForCampaign: u,
		staffUpdateCommissionInfoForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ui = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateExternalConjunction(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateExternalConjunction: u,
		staffUpdateExternalConjunctionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Wi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateLaunchDateForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateLaunchDateForCampaign: u,
		staffUpdateLaunchDateForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Gi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdatePhotosAndMediaDetailsForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdatePhotosAndMediaDetailsForCampaign: u,
		staffUpdatePhotosAndMediaDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ki = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateServiceFeeInfoForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateServiceFeeInfoForCampaign: u,
		staffUpdateServiceFeeInfoForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { on as AddressSearchStateToSearch, fe as AdjustmentCommissionType, En as AdjustmentToCommissionCondition, he as AgreementType, g as AlertType, p as AndOr, se as AustralianState, Re as BasicCampaignDetailsModelStage, Le as BasicCampaignDetailsModelState, ze as BeginCampaignState, je as BlankContractStatuses, F as BodyCorporateType, T as BuiltOnOrVacantLandType, Be as CampaignActionRequestCampaignAction, Ue as CampaignAdminModelMarketingStatus, Ve as CampaignAdminModelStage, He as CampaignAdminModelState, We as CampaignCompletionStateCompletionType, Ge as CampaignDashboardLaunchStatus, Ke as CampaignDashboardRowMarketingStatus, Ye as CampaignDetailModelBlankSalesContractStatus, Je as CampaignDetailModelStage, qe as CampaignDetailModelState, Xe as CampaignSearchResultStage, Oe as CampaignStatuses, Q as CampaignsApiContext, K as CampaignsApiException, Un as CampaignsApiProvider, f as CampaignsClient, Y as CampaignsRoute, k as Chattel, mn as Chattels, Ze as CommissionDetailsChangeInfoChangeType, _e as CommissionTypes, vn as CommunityTitlesSchemeDocumentType, ve as ComparativeType, H as Condition, V as ConditionType, A as ConditionalTextInputType, Qe as ContractActionRequestContractAction, De as ContractCompletionType, I as ContractConditionType, $e as ContractDashboardRowVendorBankDetailsStatus, et as ContractDatesConditionConfigContractDateType, Ne as ContractStatuses, _ as ContractType, le as CoolingOffCondition, we as CoolingOffType, O as CustomPdfScript, L as DayOfWeek, z as DayType, R as DepositPayable, Ee as DepositPaymentType, G as DepositType, Cn as DocuSignInfoCondition, Tt as DocumentSighted, ee as DocumentTypes, tt as EarlyReleaseOfDepositDestinationOfTransfer, re as EditScope, pn as EditablePdfButtonPdfFieldType, D as EditablePdfButtonType, fn as EditablePdfUploadCustomScript, dn as EditablePdfUploadDocumentType, h as ElementType, w as EmploymentStatus, rt as EnvelopeSubmissionModelStatus, nt as EnvelopeSubmissionModelType, it as EnvelopeSubmissionRecipientStatus, at as ExternalConjunctionConjunctionFeeType, sn as FileUploadDocumentType, pe as FlatCommissionType, ct as FormConfigurationRequestFormType, dt as FormDetailsFlow, lt as FormDetailsState, ut as FormDetailsType, ft as FormPageActionButtonType, pt as FormPageSubmitType, st as FormState, mt as FormSubmissionRequestFormType, ht as FormSubmissionRequestState, ot as FormType, v as IdentityDocument, gt as IdentityVerificationDocumentSighted, oe as IdentityVerificationExportsAggregateStatus, an as IdentityVerificationExportsModelAggregateStatus, _t as InProgressFormModelFormType, Se as IsoDayOfWeek, E as LandAreaType, vt as LaunchDateDetailsStatus, Ce as LaunchDateStatus, ke as LaunchDateStatuses, yt as LaunchDetailsStatus, x as LegalOwnershipDocument, bt as LinkedDateImpactSourceDateType, Ae as MarketingStatuses, Te as NoCoolingOffReason, Rn as NswContractRequestModelDisplaySalePriceOnceSold, zn as NswContractSubmissionModelDisplaySalePriceOnceSold, Bn as NswListingGeneratorModelVendorWaivingCoolingOffPeriod, m as Operator, gn as OwnerBuilderDeclarationCustomScript, hn as OwnerBuilderDeclarationDocumentType, U as OwnershipStructure, xt as PageStatusStatus, y as PlaceOfIssue, ye as PoolDocumentationType, P as PoolSafetyFileType, St as PrimaryProofOfIdentityDocumentSighted, Ct as ProofOfLegalOwnershipDocumentSighted, Sn as QldContractRequestModelAcquiringLandForTaxPurpose, xn as QldContractRequestModelDisplayTenantDetailsOnContract, bn as QldContractRequestModelIncludeBuyerDetailsOnContract, yn as QldContractRequestModelIncludeVendorDetailsOnContract, wn as QldContractSubmissionModelDisplaySalePriceOnceSold, Nn as QldListingSubmissionModelApprovedSafetySwitchInstalled, Pn as QldListingSubmissionModelCompliesWithSmokeAlarmLegislation, Fn as QldListingSubmissionModelGstIsPaymentRequired, Mn as QldListingSubmissionModelIncludeVendorDetailsOnContract, In as QldListingSubmissionModelNeighbourhoodDisputes, $t as QueenslandBlankContractModelApprovedSafetySwitchInstalled, en as QueenslandBlankContractModelCompliesWithSmokeAlarmLegislation, tn as QueenslandBlankContractModelGstIsPaymentRequired, Qt as QueenslandBlankContractModelIncludeVendorDetailsOnContract, nn as QueenslandBlankContractModelNeighbourhoodDisputes, Dn as QueenslandListingGeneratorModelApprovedSafetySwitchInstalled, On as QueenslandListingGeneratorModelCompliesWithSmokeAlarmLegislation, kn as QueenslandListingGeneratorModelNeighbourhoodDisputes, C as ReasonForTransaction, wt as RenderedSpecialConditionConditionType, N as RentPeriod, ce as RuralType, An as SaleDetailsState, de as SaleType, b as SecondaryIdentityDocument, be as SellersDisclosurePreparedBy, jn as SellersDisclosurePreparedByModelPreparedBy, un as SellersDisclosureUploadCustomScript, ln as SellersDisclosureUploadDocumentType, ue as SendForDocuSigningType, Dt as SendFormSubmissionModelFormType, Ot as SendFormSubmissionModelState, kt as ServiceFeeDetailsChangeInfoChangeType, Pe as SettlementDateStatuses, At as SignboardRemovalRemovalType, me as SignboardRemovalType, Et as SigningOrderGroups, ae as SolicitorType, Me as SortingOption, Ie as SortingOptionContractDashboard, jt as SpecialConditionBankTemplateConditionType, Mt as SpecialConditionDataConditionType, Nt as StaffBeginCampaignRequestState, Pt as StaffGetBlankContractDetailsForCampaignResponseBlankSalesContractStatus, Ft as StaffGetCommissionInfoForCampaignModelPartnershipLevel, It as StaffGetSaleInformationResponseSaleMethod, Rt as StaffGetSaleInformationResponseUnconditionalDisplayAs, Lt as StaffGetSaleInformationResponseUnderOfferDisplayAs, zt as StaffPreviewLinkedDatesRequestSourceDateType, Bt as StaffUpdateBlankContractDetailsForCampaignRequestBlankSalesContractStatus, Vt as StaffUpdateCommissionInfoForCampaignRequestChangeType, Ut as StaffUpdateContractTerminationRequestContractTerminationReasons, Ht as StaffUpdateContractTerminationRequestDepositEntitlement, Wt as StaffUpdateLaunchDateForCampaignRequestStatus, Gt as StaffUpdateSaleInformationRequestSaleMethod, qt as StaffUpdateSaleInformationRequestUnconditionalDisplayAs, Kt as StaffUpdateSaleInformationRequestUnderOfferDisplayAs, Jt as StaffUpdateServiceFeeInfoForCampaignRequestChangeType, te as StakeholderType, cn as SurveyPlanUploadDocumentType, _n as TenancyModelTerm, M as TenancyTerm, j as TenancyType, ge as TieredSystemType, B as TimeUnit, Tn as TypedFormDocumentModelDocumentType, Yt as UploadedDocumentDocumentType, Zt as UploadedDocumentInfoDocumentType, Xt as UploadedDocumentInfoSigningMethod, Ln as UploadedPOADocumentModelDocumentType, W as ValueType, Fe as VendorBankDetailsStatuses, ne as VendorBuyerType, rn as VendorBuyerTypes, xe as VendorCommPreference, S as VerificationMethod, ie as YesNoQuestion, lr as useAddOrUpdateDocument, zr as useBeginCampaign, Z as useCampaignsClientContext, Br as useCompleteCampaignStep, Wn as useConstructConditionClauseText, ur as useExchangeContract, er as useFormsByLocations, Vr as useGetActiveCampaigns, Yr as useGetArchivedCampaignsByAdmin, Ur as useGetArchivedCampaignsByAgency, Gr as useGetCampaign, Zr as useGetCampaignsForAgency, Gn as useGetSpecialConditionBank, or as useGetUploadedFileLink, Hr as useInvalidateUseGetActiveCampaigns, Xr as useInvalidateUseGetArchivedCampaignsByAdmin, Wr as useInvalidateUseGetArchivedCampaignsByAgency, Kr as useInvalidateUseGetCampaign, Qr as useInvalidateUseGetCampaignsForAgency, Kn as useInvalidateUseGetSpecialConditionBank, sr as useInvalidateUseGetUploadedFileLink, nr as useInvalidateUseLoadForm, Mi as useInvalidateUseStaffGetAgreementDetailsForCampaign, yi as useInvalidateUseStaffGetBlankContractDetailsForCampaign, hr as useInvalidateUseStaffGetBuyers, pr as useInvalidateUseStaffGetBuyersAgent, _r as useInvalidateUseStaffGetBuyersSolicitor, ni as useInvalidateUseStaffGetCampaign, ii as useInvalidateUseStaffGetCampaignDashboard, Pi as useInvalidateUseStaffGetCommissionInfoForCampaign, ci as useInvalidateUseStaffGetContract, oi as useInvalidateUseStaffGetContractDashboard, yr as useInvalidateUseStaffGetContractDates, xr as useInvalidateUseStaffGetContractDeposits, Cr as useInvalidateUseStaffGetContractEarlyRelease, Tr as useInvalidateUseStaffGetContractSettlement, ui as useInvalidateUseStaffGetContractsForCampaign, fi as useInvalidateUseStaffGetDocumentsForCampaign, Ii as useInvalidateUseStaffGetExternalConjunction, Ri as useInvalidateUseStaffGetLaunchDateDetailsForCampaign, Bi as useInvalidateUseStaffGetPhotosAndMediaDetailsForCampaign, $ as useInvalidateUseStaffGetPropertyDetailsForCampaign, Si as useInvalidateUseStaffGetPropertyInformationProgressForCampaign, Dr as useInvalidateUseStaffGetSaleInformation, Jn as useInvalidateUseStaffGetSpecialConditions, wi as useInvalidateUseStaffGetTenancyInformationForCampaign, hi as useInvalidateUseStaffGetUploadedFileLink, Ei as useInvalidateUseStaffGetVendorDetailsForCampaign, $n as useInvalidateUseStaffSearchForCampaign, tr as useLoadForm, Zn as useNegotiate, qr as usePerformCampaignAction, dr as usePerformContractAction, cr as useRemoveFile, Jr as useRemoveFormSubmission, rr as useSaveForm, ir as useSendForm, $r as useSetCampaignOwnership, ei as useStaffBeginCampaign, ji as useStaffGetAgreementDetailsForCampaign, vi as useStaffGetBlankContractDetailsForCampaign, mr as useStaffGetBuyers, fr as useStaffGetBuyersAgent, gr as useStaffGetBuyersSolicitor, ti as useStaffGetCampaign, ri as useStaffGetCampaignDashboard, Ni as useStaffGetCommissionInfoForCampaign, si as useStaffGetContract, ai as useStaffGetContractDashboard, vr as useStaffGetContractDates, br as useStaffGetContractDeposits, Sr as useStaffGetContractEarlyRelease, wr as useStaffGetContractSettlement, li as useStaffGetContractsForCampaign, di as useStaffGetDocumentsForCampaign, Fi as useStaffGetExternalConjunction, pi as useStaffGetFormConfiguration, Li as useStaffGetLaunchDateDetailsForCampaign, zi as useStaffGetPhotosAndMediaDetailsForCampaign, bi as useStaffGetPropertyDetailsForCampaign, xi as useStaffGetPropertyInformationProgressForCampaign, Er as useStaffGetSaleInformation, qn as useStaffGetSpecialConditions, Ci as useStaffGetTenancyInformationForCampaign, mi as useStaffGetUploadedFileLink, Ti as useStaffGetVendorDetailsForCampaign, Or as useStaffPreviewLinkedDates, gi as useStaffSaveForm, Qn as useStaffSearchForCampaign, _i as useStaffSubmitForm, Vi as useStaffUpdateAgreementDetailsForCampaign, Di as useStaffUpdateBlankContractDetailsForCampaign, Ar as useStaffUpdateBuyers, kr as useStaffUpdateBuyersAgent, jr as useStaffUpdateBuyersSolicitor, Hi as useStaffUpdateCommissionInfoForCampaign, Mr as useStaffUpdateContractComplianceFields, Nr as useStaffUpdateContractDates, Pr as useStaffUpdateContractDeposits, Fr as useStaffUpdateContractEarlyRelease, Ir as useStaffUpdateContractSettlement, Yn as useStaffUpdateContractSpecialConditionDueDate, Xn as useStaffUpdateContractSpecialConditions, Lr as useStaffUpdateContractTermination, Ui as useStaffUpdateExternalConjunction, Wi as useStaffUpdateLaunchDateForCampaign, Gi as useStaffUpdatePhotosAndMediaDetailsForCampaign, Oi as useStaffUpdatePropertyDetailsForCampaign, Rr as useStaffUpdateSaleInformation, Ki as useStaffUpdateServiceFeeInfoForCampaign, ki as useStaffUpdateTenancyInformationForCampaign, Ai as useStaffUpdateVendorDetailsForCampaign, ar as useSubmitForm };
